/** Data-driven specification rows for the customer UI. */

import { renderSpecDisplay } from '@siliconx/shared';

export interface SpecRow {
  key?: string;
  label: string;
  value: string | null | undefined;
}

/**
 * Returns a list of { label, value } rows for display in the specs section.
 * The database profile is the sole display authority for every asset class.
 */
export function specRows(
  _assetClassId: string,
  classAttributes: Record<string, unknown> | null | undefined,
  specDisplaySchema?: unknown,
): SpecRow[] {
  const result = renderSpecDisplay(specDisplaySchema, classAttributes);
  return result.status === 'ok'
    ? result.rows
    : [{ key: 'configuration', label: '', value: result.message }];
}
